import { Box } from "@mui/material"
import FilterChip from "components/FilterChip"
import { useVideosSearch } from "hooks/videos/useVideosSearch"
import ConventionTag from "models/convention-api/v1/ConventionTag"
import React from "react"
import { makeStyles } from "tss-react/mui-compat"

const useStyles = makeStyles()({
  container: {
    gridColumn: "1/-1",
    display: "flex",
    flexFlow: "row wrap",

    margin: -10,
    "& > *": {
      margin: 10,
    },
  },
})

interface VideosChipsFilterProps {
  tags: ConventionTag[]
  videosSearch: ReturnType<typeof useVideosSearch>
  onToggle: (tagId: string, isChecked: boolean) => void
}

export const VideosChipsFilter = (props: VideosChipsFilterProps) => {
  const { tags, videosSearch, onToggle } = props
  const { classes } = useStyles()

  return (
    <Box className={classes.container}>
      {tags.map((tag) => {
        const isChecked = videosSearch.tagIds.includes(tag.id)
        const handleClick = () => {
          onToggle(tag.id, isChecked)
        }
        return (
          <FilterChip key={tag.id} label={tag.name} isChecked={isChecked} onClick={handleClick} />
        )
      })}
    </Box>
  )
}
